import { render } from "./delivery-challan.vue?vue&type=template&id=2619e2dc&scoped=true"
import script from "./delivery-challan.vue?vue&type=script&lang=js"
export * from "./delivery-challan.vue?vue&type=script&lang=js"

import "./delivery-challan.vue?vue&type=style&index=0&id=2619e2dc&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2619e2dc"]])

export default __exports__